import React, { useCallback, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";

import Container from "@material-ui/core/Container";
import ContentBrowser from "./browse/ContentBrowser";
import withAuthorization from "../../auth/withAuthorization";
import { useEditScreenClose } from "../use-editScreenClose";
import { Route, useLocation, useRouteMatch } from "react-router-dom";
import { useSearch } from "../searchServices";
import { lensProp, mergeDeepRight, set } from "ramda";
import { creatorRoles } from "../CreatorApplication";
import ContentEdit from "./edit/ContentEdit";

const useStyles = makeStyles(theme => ({
  panel: {
    display: "flex",
    flexDirection: "column",
    height: "95%",
    padding: "0",
    border: "3px solid white",
    background: "white",
    borderRadius: "20px",
  },
}));

const initialState = (initialState = {}, initialSearch) => {
  return set(
    lensProp("appliedQuery"),
    initialSearch,
    mergeDeepRight(
      {
        appliedQuery: [],
        appliedFacets: [
          {
            name: "type",
            queryParam: "_type",
            terms: [
              {
                code: "CONTENT",
              },
            ],
          },
          {
            name: "status",
            queryParam: "status",
            // This gets content with ANY status: APPROVED, PENDING, REJECTED, TAKEDOWN, null
            terms: [{ code: "(-status:* AND *:*)" }, { code: "status:*" }],
          },
        ],
        orderBy: null,
        orderDirection: "asc",
        page: 0,
        limit: 10,
      },
      initialState,
    ),
  );
};

const initialSearchState = {
  noFacets: true,
};

const initialFacetState = {
  noFacets: false,
  facetsOnly: true,
};

// TODO: refactor edit dialog routing
// Setting withAuthorization to false to not show unauthorized screen because
// unauthorized screen flashes when navigating to and away from edit screen for non-Admin users
const AuthorizedRoute = withAuthorization(Route, false);

const ContentView = () => {
  const classes = useStyles();
  const { path } = useRouteMatch();
  const location = useLocation();
  const initialSearchValue =
    location?.state?.search?.content?.appliedQuery ?? [];

  const [searchState, setSearchState] = useState(
    initialState(initialSearchState, initialSearchValue),
  );
  const [facetState, setFacetState] = useState(
    initialState(initialFacetState, initialSearchValue),
  );

  const searchResults = useSearch(searchState);
  const facetResults = useSearch(facetState);

  const handleEditScreenClose = useEditScreenClose("/content");

  const handleSave = useCallback(() => {
    handleEditScreenClose();
    searchResults.refetch();
    console.log("location from content view: ", location);
  }, [searchResults, handleEditScreenClose, location]);

  const handleCancel = useCallback(() => {
    handleEditScreenClose();
  }, [handleEditScreenClose]);

  return (
    <Container
      id="content-view"
      disableGutters
      maxWidth={false}
      classes={{ root: classes.panel }}
    >
      <AuthorizedRoute exact path={`${path}`} roles={["ROLE_ADMIN"]}>
        <ContentBrowser
          searchState={searchState}
          facetState={facetState}
          onSearchStateChange={state => setSearchState(state)}
          onFacetStateChange={state => setFacetState(state)}
          searchResults={searchResults}
          facetResults={facetResults}
          onSaveSuccess={handleSave}
        />
      </AuthorizedRoute>

      <AuthorizedRoute path={`${path}/:id`} roles={creatorRoles}>
        <ContentEdit onCancel={handleCancel} onSaveSuccess={handleSave} />
      </AuthorizedRoute>
    </Container>
  );
};

export default ContentView;
